type ContentType = 'application/pdf' | 'image/jpeg' | 'image/png' | 'image/svg+xml';

export const uploadFileToS3 = async (
  url: string,
  file: File,
  fileType: ContentType,
  // Headers that were signed into the presigned URL must be sent verbatim on the PUT
  extraHeaders?: Record<string, string>,
) => {
  const response = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': fileType, ...extraHeaders },
    body: file,
  });

  if (!response.ok) {
    throw new Error('Failed to upload file');
  }
};

export const uploadImagesToS3 = async (
  presignedItems: PolicyImagePresignedUrlItem[],
  files: File[],
): Promise<void> => {
  await Promise.all(
    presignedItems.map((item, index) => {
      const file = files[index];
      const contentType = file.type as ContentType;
      return uploadFileToS3(item.url, file, contentType);
    }),
  );
};
